// export const RALocation = {
//     Burgenland: "Burgenland",
//     Kärnten: "OLG Innsbruck",
//     Niederösterreich: "OLG Linz",
//     Oberösterreich: "OLG Wien",
//     Salzburg:"Salzburg",
//     Steiermark:"Steiermark",
//     Tirol:"Tirol",
//     Vorarlberg:"Vorarlberg",
//     Wien:"Wien",
// };

export const RALocation = ["Burgenland","Innsbruck",
    "Linz",
   "Wien",
    "Salzburg",
    "Steiermark",
    "Tirol",
    "Vorarlberg",
    "Wien",
];



export default [
    {
        RALocation: RALocation.Burgenland,
        Hauptstadt: 26,
        Land: 47

    },
    {
        RALocation: RALocation.Kärnten,
        Hauptstadt: 145,
        Land: 117

    },
    {
        RALocation: RALocation.Niederösterreich,
        Hauptstadt: 64,
        Land: 410

    },
    {
        RALocation: RALocation.Oberösterreich,
        Hauptstadt: 309,
        Land: 381

    },
    {
        RALocation: RALocation.Salzburg,
        Hauptstadt: 331,
        Land: 92

    },
    {
        RALocation: RALocation.Steiermark,
        Hauptstadt: 355,
        Land: 213

    },
    {
        RALocation: RALocation.Tirol,
        Hauptstadt: 335,
        Land: 216

    },
    {
        RALocation: RALocation.Vorarlberg,
        Hauptstadt: 49,
        Land: 187

    },
    {
        RALocation: RALocation.Wien,
        Hauptstadt: 3328,

    },
]